import lodash from 'lodash';
import {auth} from '../../system/api';
import {router, url} from '../../system/routing';
import {getState} from '../../system/store';
import authConfig from '../../config/auth';

class AuthService {
    /**
     * Kiểm tra client đã login hay chưa
     *
     * @return {boolean}
     */
    isLogged() {
        return !!auth.getToken();
    }

    /**
     * Thực hiện login
     */
    login(location) {
        auth.removeToken();
        sessionStorage.setItem('auth.url_return', url.location().pathname + url.location().search);
        router.redirect('/login', location);
    }

    /**
     * Login success
     */
    loginSuccess(token) {
        const urlReturn = sessionStorage.getItem('auth.url_return');
        auth.setToken(token);
        urlReturn ? url.redirect(urlReturn) : url.redirect('/');
        sessionStorage.removeItem('auth.url_return');
    }

    /**
     * Thực hiện logout
     */
    logout() {
        auth.removeToken();
        window.location = authConfig.logoutUrl;
    }

    /**
     * Lấy thông tin user hiện tại
     *
     * @param {string|null} key
     * @param {*} defaultValue
     * @return {*}
     */
    user(key = null, defaultValue = null) {
        let user = getState('auth.user');
        return key === null ? user : lodash.get(user, key, defaultValue);
    }

    partner(key = null, defaultValue = null) {
        let user = getState('auth.partner.meta');
        return key === null ? user : lodash.get(user, key, defaultValue);
    }

    lou_stamp_url() {
        return getState('auth.lou_stamp_url');
    }

    lou_stamp_url_auto() {
        return getState('auth.lou_stamp_url_auto');
    }

    /**
     * Trả về true nếu user hiện tại được phân TÁT CẢ các permissions truyền vào
     * VD: auth.can('GET'), auth.can(['GET', 'CREATE'])
     *
     * @param {string|array} permissions
     * @return {boolean}
     */
    can(permissions) {
        permissions = lodash.isArray(permissions) ? permissions : [permissions];
        let userPermissions = this.user('permissions') || [];
        if (lodash.get(userPermissions, 0, '') === '*') {
            return true;
        }

        return lodash.every(permissions, permission => userPermissions.includes(permission));
    }

    /**
     * Trả về true nếu user hiện tại được phân MỘT TRONG các permissions truyền vào
     * VD: auth.can('GET'), auth.can(['GET', 'CREATE'])
     *
     * @param {string|array} permissions
     * @return {boolean}
     */
    canAny(permissions) {
        permissions = lodash.isArray(permissions) ? permissions : [permissions];
        let userPermissions = this.user('permissions') || [];

        return lodash.some(permissions, permission => userPermissions.includes(permission));
    }

    getPartnerConfig(key, code) {
        let items = getState(`auth.partner.${key}`);
        if (Array.isArray(items)) {
            for (let item of items) {
                if (item.code === code) {
                    return item;
                }
            }
        }
        return null;
    }

    getPartnerConfigSetting(key, code) {
        let items = getState(`setting.${key}`);
        if (Array.isArray(items)) {
           
            for (let item of items) {
                if (item.code === code) {
                    return item;
                }
            }
        }
        return null;
    }
}

let authService = new AuthService();

export default authService;
